import MaskPhone from "@/directives/MaskPhone";

export default[
    MaskPhone
];